<div class="container-fluid py-4 px-3 d-flex flex-column gap-4">

    <!-- Top Overview Cards (Personal Standing & Summary stats) -->
    <div class="row g-4 align-items-stretch">

        <!-- Top Row: Leaderboard Queue Picker & Search (Full Width) -->
        <div class="col-12 d-flex flex-column justify-content-between gap-3">
            <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 bg-dark p-4 rounded-4 border-0"
                style="--bs-bg-opacity: 0.35;">
                <div>
                    <h2 class="h4 fw-extrabold text-uppercase text-white mb-1">Leaderboards</h2>
                    <p class="text-secondary small mb-0 font-light-height">Ranks are updated dynamically based on
                        official matchmaking stats.</p>
                </div>

                <div class="d-flex flex-wrap gap-2 text-capitalize">
                    @for (game of queues(); track game) {
                    <button class="btn btn-queue-tab" [class.active]="activeQueue() === game"
                        (click)="selectQueue(game)">
                        {{ game }}
                    </button>
                    }
                </div>
            </div>

            <!-- Search input bar -->
            <div class="input-group sleek-search" style="max-width: 350px;">
                <span class="input-group-text"><i class="bi bi-search"></i></span>
                <input type="text" class="form-control" placeholder="Search rankings by nickname..."
                    [ngModel]="searchQuery()" (ngModelChange)="searchQuery.set($event)">
            </div>
        </div>

    </div>

    <!-- Bottom Row: Leaderboard Widget (Left) + Distribution List (Right) -->
    <div class="row g-4">

        <!-- Left: Leaderboard Widget (matching overview.html leaderboard card exactly) -->
        <div class="col-12 col-lg-8">
            <div class="leaderboard-card">

                @if (leaderboardLoading()) {
                <div class="d-flex flex-column align-items-center justify-content-center py-5 text-muted">
                    <div class="spinner-border text-primary mb-3" role="status"
                        style="border-color: #9f50ff transparent #9f50ff transparent; width: 2rem; height: 2rem;">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <small class="text-uppercase tracking-wider" style="font-size: 0.75rem;">Loading RIVAL FORGE
                        Rankings...</small>
                </div>
                } @else {
                <div class="leaderboard-list">
                    @for (player of filteredLeaderboard(); track player.id; let idx = $index) {
                    <div class="d-flex align-items-center p-3 leaderboard-item">
                        <!-- Rank Badge -->
                        <div class="rank-badge flex-shrink-0 me-3" [class.rank-1]="skip() + idx === 0"
                            [class.rank-2]="skip() + idx === 1" [class.rank-3]="skip() + idx === 2"
                            [class.rank-other]="skip() + idx > 2">
                            {{ skip() + idx + 1 }}
                        </div>

                        <!-- Player details -->
                        <div class="flex-grow-1 overflow-hidden">
                            <h6 class="fw-bold text-truncate mb-0 text-white player-name">{{ player.nickname }}</h6>
                            <small class="text-muted d-flex align-items-center gap-2">
                                <span>W: <strong class="text-success">{{ player.gamesWon }}</strong></span>
                                <span>L: <strong class="text-danger">{{ player.gamesLost }}</strong></span>
                                <span>WR: <strong class="text-info">{{ player.gamesPlayed > 0 ? (player.gamesWon /
                                        player.gamesPlayed * 100 | number:'1.0-0') : 0 }}%</strong></span>
                            </small>
                        </div>

                        <!-- ELO Rating -->
                        <div class="text-end">
                            <div class="rating-value fs-5">{{ player.rating }}</div>
                            <div class="player-stat-label">Rating</div>
                        </div>
                    </div>
                    } @empty {
                    <div class="text-center text-secondary py-5">
                        <i class="bi bi-suit-spade-fill fs-1 d-block mb-3 text-muted"></i>
                        <h5 class="fw-bold text-white text-uppercase">No ranks found</h5>
                        <p class="small mb-0">No active statistics compiled yet for game queue "{{ activeQueue() }}".
                        </p>
                    </div>
                    }

                    <!-- Pagination Controls -->
                    <div class="d-flex align-items-center justify-content-between pt-3 mt-3 border-top border-secondary"
                        style="--bs-border-opacity: 0.15;">
                        <button class="btn btn-outline-secondary btn-sm px-3 d-flex align-items-center gap-1"
                            [disabled]="!hasPrevPage()" (click)="prevPage()">
                            <i class="bi bi-chevron-left"></i> Previous
                        </button>

                        <span class="text-secondary small fw-bold">Page {{ (skip() / 10) + 1 }}</span>

                        <button class="btn btn-outline-secondary btn-sm px-3 d-flex align-items-center gap-1"
                            [disabled]="!hasNextPage()" (click)="nextPage()">
                            Next <i class="bi bi-chevron-right"></i>
                        </button>
                    </div>
                </div>
                }

            </div>
        </div>

        <!-- Right: Rank Distributions -->
        <div class="col-12 col-lg-4">
            <div class="card bg-dark border-0 rounded-4 overflow-hidden" style="--bs-bg-opacity: 0.2;">
                <div class="card-header bg-black py-3 px-4 border-bottom-0 d-flex justify-content-between align-items-center"
                    style="--bs-bg-opacity: 0.25;">
                    <h5 class="h6 fw-extrabold text-uppercase text-white mb-0">Rank Distributions</h5>
                    <div class="position-relative">
                        <button type="button" class="btn btn-link p-0 border-0 text-secondary" (click)="toggleInfo()"
                            aria-label="System rating boundaries">
                            <i class="bi bi-info-circle" style="font-size: 0.9rem;"></i>
                        </button>

                        @if (showInfo()) {
                        <div class="position-absolute end-0 mt-2 p-3 bg-dark border border-secondary rounded-3 shadow-lg text-white text-start"
                            style="width: 280px; z-index: 1000; --bs-bg-opacity: 0.95; font-size: 0.92rem;">
                            <div class="d-flex justify-content-between align-items-center mb-2 border-bottom border-secondary pb-1"
                                style="--bs-border-opacity: 0.25;">
                                <span class="fw-bold text-uppercase text-info">Matchmaking Info</span>
                                <button type="button" class="btn-close btn-close-white"
                                    (click)="toggleInfo(); $event.stopPropagation();" style="font-size: 0.6rem;"
                                    aria-label="Close"></button>
                            </div>
                            <p class="mb-2 text-secondary">Ranks and tiers are calculated using ELO rating system
                                values.</p>
                            <ul class="ps-3 mb-0 text-secondary" style="line-height: 1.5;">
                                <li>Winning matches increases rating.</li>
                                <li>Losing matches decreases rating.</li>
                                <li>Earn bonus ELO on active win streaks.</li>
                            </ul>
                        </div>
                        }
                    </div>
                </div>
                <div class="card-body p-4 d-flex flex-column gap-3">
                    @for (tier of tiers(); track tier.name) {
                    <div class="d-flex justify-content-between align-items-center p-2.5 rounded-3 border border-secondary transition-all"
                        style="--bs-border-opacity: 0.3;">

                        <div class="d-flex align-items-center gap-2">
                            <!-- Small indicator dot -->
                            <span class="p-1 rounded-circle" [class]="tier.colorClass"
                                style="width: 8px; height: 8px;"></span>
                            <span class="fw-bold small text-uppercase" [class]="tier.colorClass">{{ tier.name }}</span>
                        </div>

                        <div class="text-end small">
                            <span class="text-white fw-bold d-block" style="font-size: 0.78rem;">{{ tier.eloRange }}
                                ELO</span>
                            <span class="text-secondary" style="font-size: 0.72rem;">{{ tier.percentile }}</span>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>

    </div>

</div>